export default {"src":"/_next/static/media/data-integrity-testing.1be9fc7b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};